import { 
    LOADING, 
    GET_USERS, 
    SAVE_USER, 
    SAVE_NEW_USER, 
    PATCH_ACCOUNT_USER,
    DISLABED_USER,
    SAVE_LIQUIDATION,
    DELETE_LIQUIDATION
 } from "../../../types";

 import { formatedRun } from '../../../utils/RunUtil'
// eslint-disable-next-line import/no-anonymous-default-export
export default (state, action) => {
    switch (action.type) {
            case GET_USERS:               
                return {
                ...state,
                users: action.payload
            }
            case PATCH_ACCOUNT_USER:        
                return {
                    ...state,
                    users: state.users.map(user => {
                        if(user.run === formatedRun(action.payload.run)){return action.payload;}
                        else{return user;}
                    })
                }
            case SAVE_NEW_USER:
                return {
                    ...state,
                    users: [...state.users, action.payload],
                }
            case DISLABED_USER:
                return {
                    ...state,
                    users: state.users.filter( user => user.email !== action.payload),
                }
            case SAVE_USER:
                return {
                    ...state,
                    userSelected: action.payload
                }    
           case LOADING:               
               return {
                   ...state,
                   loading: !state.loading
               }
            case SAVE_LIQUIDATION:
                let auxUser = { ...state.userSelected, liquidations: [...state.userSelected.liquidations, action.payload] }
                auxUser.liquidations.sort( (l1, l2) => parseInt(l1.period.name.split('-')[1]+l1.period.name.split('-')[0]) - parseInt(l2.period.name.split('-')[1]+l2.period.name.split('-')[0]) ) 
                return {
                    ...state, 
                    userSelected: auxUser,
                    users: state.users.map(user => {
                        if(user.run === auxUser.run){
                            return auxUser;
                        } else{
                            return user;
                        }
                    } ) 
                }
            case DELETE_LIQUIDATION:
                let auxUser2 = {
                                ...state.userSelected,
                                liquidations: state.userSelected.liquidations.filter(liquidation => liquidation.id !== action.payload)
                            }
                return {
                    ...state,
                    userSelected: auxUser2 ,
                    users: state.users.map(user => {
                        if(user.run === auxUser2.run){
                            return auxUser2;
                        } else{
                            return user;
                        }
                    } )                 
                }
        default:
            return state;
    }
}